import React from 'react';

import LoanApplicationPage from './LoanApplicationPage';

const LoanApplicationIframePageWrapper = () => {
  return <LoanApplicationPage isOpenInIframe />;
};

export default LoanApplicationIframePageWrapper;
